<template>
  <div class="Risk" style="background-color: white">
    <div style="height: 58px;background-color: white;border-bottom: 2px solid #E1E1E1;">
      <el-col :span="19" :offset="5">
        <div style="float: left">
          <img src="./images/logo3.svg"  />
          <!--          ../../public/favicon.ico-->
        </div>
        <div style="margin-left: 160px">
          <span style="font-size: 28px;color: #2B78D9;margin-left: -110px;font-weight: bolder">通辽市能碳管理中心</span>
        </div>
      </el-col>
    </div>
    <div style="background: #FFFFFF;">
      <div style="width: 1200px;margin: auto;height: 15px;margin-top: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 14px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
<!--          <el-breadcrumb-item :to="{ path: '/'+ pathName,query:{titleName:title,activeName:activeName}}">{{title}}</el-breadcrumb-item>-->
          <el-breadcrumb-item>{{contentTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div style="width: 1200px;border: 2px solid #EEEEEE;margin: auto;margin-top: 10px">
        <div style="font-size: 28px;font-weight: bold;width: 700px;text-align: center;margin: auto;height: 74px;">
          <sapn>
            {{contentTitle}}
          </sapn>
        </div>
        <div style="width: 500px;margin: auto;height: 20px;margin-top: 10px">
          <sapn style="float: right">发布时间：{{contentDate.slice(0,10)}}</sapn>
        </div>
        <div style="height: 3px;width: 1113px;border-top: 2px solid #E7E7E7;margin: auto;margin-top: 10px"></div>
        <div style="width: 1100px;margin: auto;min-height: 700px">
          <div style="text-indent: 2em;margin-top: 20px">
            <span v-html="resultData.content"></span>
          </div>
        </div>
      </div>
<!--      <div style="width: 1200px;margin: auto;height: 50px;margin-top: 10px">-->
<!--        <button @click="backToTable" style="color: #2B78D9;background-color: white;border: 2px solid #2B78D9;font-size: 18px;cursor: pointer;">-->
<!--          返回列表-->
<!--        </button>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
import data from '@/assets/test.json';
import * as Setting from "@/setting";
import {getHalo} from "@/setting";
import axios from "axios";
const config = {
  headers: {
    'Authorization': 'Basic aGFsb2FkbWluOkNhUmJvbkAyNC4y', // 设置认证令牌
    // 'Authorization': 'Basic c3ViaW5naGU6MTIzNDU2', // 设置认证令牌
    // 'Authorization': 'Basic YWRtaW46Rmd3XzIwMjQh', // 设置认证令牌
    'Content-Type': 'application/json' // 设置内容类型为JSON
  }
};
export default {
  data() {
    return {
      resultData:{},
      jsonData: data,
      title:this.$route.query.titleName,
      activeName: this.$route.query.activeName,
      resultIndex: this.$route.query.resultIndex,
      contentTitle:this.$route.query.contentTitle,
      contentDate:this.$route.query.contentDate,
      activeId: 1,
      pathName:'tableDetail',
      tabPosition: "left",
      tabList: [
        { id: 1, job: "分类系统" },
        { id: 2, job: "查询系统" },
        { id: 3, job: "小贴士" },
      ],
    };
  },
  created() {
    this.showData();
    this.$emit('header',false);
  },
  methods: {
    showData(){
      let that =this;
      console.log("that.$route.query.contentId",that.$route.query.contentId)
      axios.get(Setting.getHalo()+'/v1alpha1/posts/'+that.$route.query.contentId+'/head-content',
          config ).then(response => {
        that.resultData=response.data;
      });
    },
    backToTable(){
      console.log(this.$route.query.resultData);
      console.log(this.resultData);
      this.$router.push("/wordDetail");
      // title
      this.$router.push({
        path: this.pathName,
        query: {titleName:this.title,activeName:this.activeName}
        // query: {titleName:title,activeName:activeName},
      })
    },
  },

};
</script>
<style lang="less" scoped>
.Risk {
  background: #f2f2f2;
  //width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}
.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #dd2126;
}

.isActive {
  background: #fce9ea;
}
.left {
  width: 180px;
  height: 267px;
  background-color: white;
}
.smallBox {
  width: 180px;
  height: 52px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 52px;
  text-align: center;
}
.top {
  margin-top: 24px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #dd2126;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  font-size: 16px;
  line-height: 50px;
  color: white;
}
.right {
  margin-left: 20px;
  width: 1000px;
  min-height: 712px;
  background-color: white;
  padding: 41px 40px;
  box-sizing: border-box;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
.blue {
  color: #2B78D9;
}
</style>
